import React, { createContext, useContext } from 'react';

type FlowRuntimeMode = 'live' | 'preview';
interface FlowRuntimeContextValue {
  mode: FlowRuntimeMode;
  refreshMedia?: () => Promise<void>;
  refreshingMedia?: boolean;
  mediaRevision?: number;
  surveyInviteCode?: string;
  paymentsEnabled?: boolean;
}
const FlowRuntimeContext = createContext<FlowRuntimeContextValue>({ mode: 'live' });
export const FlowRuntimeProvider: React.FC<React.PropsWithChildren<FlowRuntimeContextValue>> = ({ children, ...value }) => (
  <FlowRuntimeContext.Provider value={value}>{children}</FlowRuntimeContext.Provider>
);
export function useFlowRuntime() { return useContext(FlowRuntimeContext); }
